import "./style.css";

export default class GatedFile {
  static selector = ".gated-file";

  constructor(block) {
    this.block = block;
    this.label = this.block.querySelector(".gated-file__label");
    this.cta = this.block.querySelector(".gated-file__cta");

    // get data
    this.fileId = this.block.dataset.id;
    this.modalTitle = this.block.dataset.modalTitle;

    this.label.addEventListener("click", this.handleModalOpening);
    this.cta.addEventListener("click", this.handleModalOpening);
  }

  handleModalOpening = async () => {
    if (!window.App.modals.GatedFileModal) {
      return;
    }

    if (!this.fileId) {
      return;
    }

    window.App.modals.GatedFileModal.open();
    window.App.modals.GatedFileModal.update({
      fileId: this.fileId
    });
  };
}
